import { enumValidator } from '#validation/common/validators';
import { StorageOwner } from '../constants';
export const storageOwnerValidator = enumValidator({
    values: StorageOwner,
    requiredError: 'filespace.storageOwner.required',
    invalidValueError: 'filespace.storageOwner.invalid',
});
